import { Component, ViewChild, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { DateFormats } from '../../providers/app-date-adapter';
import * as moment from 'moment';

export const DATE_EDIT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DateEditComponent),
  multi: true,
};

@Component({
  moduleId: module.id,
  selector: 'app-date-edit',
  templateUrl: './date-edit.component.html',
  providers: [DATE_EDIT_VALUE_ACCESSOR],
})

export class DateEditComponent implements ControlValueAccessor {
  @ViewChild('input', { static: true }) input;
  @Input() placeholder;
  @Input() min: Date;
  @Input() max: Date;
  @Input() required = false;
  @Input() readOnly = false;
  @Input() disabled = false;
  @Output() onChanged = new EventEmitter<any>();
  @Input() prefill: Date;
  date: any;
  onChange;
  onTouched;
  constructor() {
    const i = 0;
   }

  change() {
    if (this.date instanceof moment) {
      if ( (this.max === undefined || this.date <= moment(this.max))
        && (this.min === undefined || this.date >= moment(this.min)) ) {
        const d = (this.date as any).format(DateFormats.MomentForSendFormat);
        this.onChange(d);
        this.onChanged.emit(this.date);
      } else {
        this.onChange(null);
      }
    } else if ( !this.date ) {
      this.onChange(null);
    }
  }

  writeValue(value: any): void {
      this.date = value ? moment(value) : null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // This must set the internal “disabled” state of the custom checkbox
    this.disabled = isDisabled;
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedRegex = /[0-9\.]/g;

    if (!event.key.match(allowedRegex)) {
      event.preventDefault();
    }
  }
}
